import isEmpty from 'lodash/isEmpty';
import { useCallback, useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { noop } from 'shared/utils/misc';
import styled from 'styled-components';
import { reactSelectStyle } from './styles';

const separators = [' ', ',', ', '];
const withoutMenuAndDropdownIndicator = {
  Menu: () => null,
  IndicatorsContainer: () => null,
};
const DuplicateWarning = styled.div`
  top: -1.5rem;
`;

export default function MultiInput({
  defaultValue = [],
  isDisabled = false,
  onChange = noop,
  ...props
}) {
  const ref = useRef(null);
  const [input, setInput] = useState('');
  const [options, setOptions] = useState([]);
  const [duplicateFound, setDuplicateFound] = useState(false);
  const customStyles = reactSelectStyle(false, true);

  const addOption = useCallback((value) => {
    const newValue = value.replace(/[, ]+/g, '');
    const isDuplicate = options.some((i) => i.value === newValue);
    if (!newValue) return;
    if (isDuplicate) {
      setDuplicateFound(true);
    } else {
      setDuplicateFound(false);
      setOptions(prevOptions => [...prevOptions, { value: newValue, label: newValue }]);
      setInput('');
    }
  }, [options]);

  const handleBlur = useCallback(() => {
    const currentInput = ref.current?.props?.inputValue || '';
    if (currentInput) addOption(currentInput);
  }, [addOption]);

  const handleRemove = useCallback((_, { action, removedValue }) => {
    if (action === 'clear') setOptions([]);
    if (action === 'remove-value') {
      const { value, label } = removedValue;
      setOptions(
        options.filter((opt) => opt.value !== value && opt.label !== label)
      );
    }
  }, [options]);

  const handleChange = useCallback((value, { action }) => {
    if (action === 'input-change') {
      const isSeparatorTyped = separators.some((s) => value.includes(s));
      if (isSeparatorTyped) {
        addOption(value);
      } else {
        setInput(value);
        setDuplicateFound(false);
      }
    }
  }, [addOption]);

  useEffect(()=> {
    if (isEmpty(defaultValue) || !Array.isArray(defaultValue)) return;
    setOptions(
      defaultValue.map((o) => ({ value: o.value, label: o.value }))
    );  
  }, []);

  useEffect(() => {
    onChange(options.map((o) => o.value));
  }, [options]);

  return (
    <div className="position-relative">
      {duplicateFound && (
        <DuplicateWarning className="position-absolute fs-7 end-0 text-danger">
          Duplicate found
        </DuplicateWarning>
      )}
      <Select
        isMulti
        isClearable
        isSearchable
        isDisabled={isDisabled}
        ref={ref}
        inputRef={ref}
        value={options}
        options={options}
        inputValue={input}
        onBlur={handleBlur}
        onChange={isDisabled ? noop : handleRemove}
        onInputChange={isDisabled ? noop : handleChange}
        components={withoutMenuAndDropdownIndicator}
        styles={customStyles}
        {...props}
      />
    </div>
  );
}
